import { Backdrop } from "components/atoms/modal";
import { MouseEvent, ReactNode, useState } from "react";
import { createPortal } from "react-dom";

interface Props {
  activator: (e: () => void) => ReactNode;
  modal: (e: () => void) => ReactNode;
  backdropHidden?: boolean;
  isActive?: boolean;
  disableClickBack?: boolean;
}

// 모달 레이아웃 공통
const Modal = ({
  activator,
  modal,
  backdropHidden,
  isActive,
  disableClickBack,
}: Props) => {
  const [show, setShow] = useState(isActive);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    if (disableClickBack) return;
    if (e.currentTarget === e.target) handleClose();
  };

  return (
    <>
      {activator(handleOpen)}
      {show &&
        createPortal(
          <>
            {modal(handleClose)}
            {!backdropHidden && <Backdrop onClick={handleClick}></Backdrop>}
          </>,

          document.getElementById("modals") as HTMLElement
        )}
    </>
  );
};

export default Modal;
